import axiosInstance from "./axios";

import authentication from "@/services/authentication";
import company from "@/services/company";
import accountManager from "@/services/accountManager";
import accountAdmin from "@/services/accountAdmin";
import branch from "@/services/branch";
import driver from "@/services/driver";
import vehicle from "@/services/vehicle";
import warehouse from "@/services/warehouse";
import integrationPartner from "@/services/integrationPartner"
import customer from "@/services/customer";
import customerAddress from "@/services/customerAddress";
import item from "@/services/item";
import itemUnit from "@/services/itemUnit";
import saleOrder from "@/services/saleOrder";
import paymentMethod from "@/services/paymentMethod";
import normalUser from "@/services/normalUser";
import profile from "@/services/profile";
import trip from "@/services/trip";
import order from "@/services/order";
import tripPlanning from "@/services/tripPlanning";
import tripPlanningTemplate from "@/services/tripPlanningTemplate";
import regionRestriction from "@/services/regionRestriction";
import driverZone from "@/services/driverZone";
import bulkUpload from "@/services/bulkUpload";
import newOperation from "@/services/newOperation";
import operation from "@/services/operation";
import chat from "@/services/chat";
import userNotification from "@/services/userNotification";
import fieldConfiguration from "@/services/fieldConfiguration";
import module from "@/services/module";
import tag from "@/services/tag";
import role from "@/services/role";
import adhocOrder from "@/services/adhocOrder";
import logs from "@/services/logs";
import vehicleTags from "@/services/vehicleTags";
import customerAddressTags from "@/services/customerAddressTags";
import vehicleDocuments from "@/services/vehicleDocuments";
import driverDocuments from "@/services/driverDocuments";
import clientDashboard from "@/services/clientDashboard";
import theme from "@/services/theme";
import integrationLogs from "@/services/integrationLogs";
import subscription from "@/services/subscription";
import reports from "@/services/reports";
import integration from "@/services/integration";
import support from "@/services/support";
import supportUser from "@/services/supportUser";
import supportUserTicket from "@/services/supportUserTicket";
import project from "@/services/project";
import orderNew from "@/services/orderNew";
import customerLocationUpdate from "@/services/customerLocationUpdate";
import orderTracking from "@/services/orderTracking";
import consigneeManagement from "@/services/consigneeManagement";
import currency from "@/services/currency";
import announcement from "@/services/announcement";
import systemAdminDashboard from "@/services/systemAdminDashboard";
import tripExpense from "@/services/tripExpense";
import customField from "@/services/customField";
import vehicleType from "@/services/vehicleType";
import licenseType from "@/services/LicenseType";
import permitType from "@/services/permitType";
import apiToken from "@/services/apiToken";
import telematicsVendor from "@/services/telematicsVendor";
import storageType from "@/services/storageType";

export default {
  authentication: authentication(axiosInstance),
  company: company(axiosInstance),
  accountManager: accountManager(axiosInstance),
  accountAdmin: accountAdmin(axiosInstance),
  branch: branch(axiosInstance),
  driver: driver(axiosInstance),
  vehicle: vehicle(axiosInstance),
  warehouse: warehouse(axiosInstance),
  integrationPartner:integrationPartner(axiosInstance),
  customer: customer(axiosInstance),
  customerAddress: customerAddress(axiosInstance),
  item: item(axiosInstance),
  itemUnit: itemUnit(axiosInstance),
  saleOrder: saleOrder(axiosInstance),
  adhocOrder: adhocOrder(axiosInstance),
  order: order(axiosInstance),
  paymentMethod: paymentMethod(axiosInstance),
  normalUser: normalUser(axiosInstance),
  consigneeManagement: consigneeManagement(axiosInstance),
  profile: profile(axiosInstance),
  trip: trip(axiosInstance),
  tripPlanning: tripPlanning(axiosInstance),
  tripPlanningTemplate: tripPlanningTemplate(axiosInstance),
  regionRestriction: regionRestriction(axiosInstance),
  driverZone: driverZone(axiosInstance),
  bulkUpload: bulkUpload(axiosInstance),
  newOperation: newOperation(axiosInstance),
  operation: operation(axiosInstance),
  chat: chat(axiosInstance),
  userNotification: userNotification(axiosInstance),
  fieldConfiguration: fieldConfiguration(axiosInstance),
  module: module(axiosInstance),
  tag: tag(axiosInstance),
  role: role(axiosInstance),
  logs: logs(axiosInstance),
  vehicleTags: vehicleTags(axiosInstance),
  customerAddressTags: customerAddressTags(axiosInstance),
  vehicleDocuments: vehicleDocuments(axiosInstance),
  driverDocuments: driverDocuments(axiosInstance),
  clientDashboard: clientDashboard(axiosInstance),
  theme: theme(axiosInstance),
  integrationLogs: integrationLogs(axiosInstance),
  subscription: subscription(axiosInstance),
  reports: reports(axiosInstance),
  integration: integration(axiosInstance),
  support: support(axiosInstance),
  supportUser: supportUser(axiosInstance),
  supportUserTicket: supportUserTicket(axiosInstance),
  project: project(axiosInstance),
  orderNew: orderNew(axiosInstance),
  orderTracking: orderTracking(axiosInstance),
  customerLocationUpdate: customerLocationUpdate(axiosInstance),
  currency: currency(axiosInstance),
  announcement: announcement(axiosInstance),
  systemAdminDashboard: systemAdminDashboard(axiosInstance),
  tripExpense: tripExpense(axiosInstance),
  customField: customField(axiosInstance),
  vehicleType: vehicleType(axiosInstance),
  licenseType: licenseType(axiosInstance),
  permitType: permitType(axiosInstance),
  apiToken: apiToken(axiosInstance),
  telematicsVendor: telematicsVendor(axiosInstance),
  storageType: storageType(axiosInstance),
};
